import { OverlayPanel } from 'primeng/overlaypanel';
import { SyntheticColumnBuilderComponent } from './synthetic-column/synthetic-column-builder.component';
import { ReportDashboardConfigComponent } from './report-dashboard-config.component';
import { TreeNode, MenuItem, ConfirmationService } from 'primeng/api';
import { AwsUtil } from '../authentication/aws.service';
import { DashboardEventService } from '../dashboard/dashboard-event.service';
import { Subscription } from 'rxjs';
import { Component, OnInit, ViewEncapsulation, OnDestroy, AfterViewInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
    ReportDashboardQueryRequest,
    WebApiEndpoints,
    ReportDashboardConfig,
    ReportDashboardComponentConfig,
    PreviewReportDashboardRequest,
    PreviewReportDashboardResult,
    ReportDashboardPublishingConfig,
    ViewSavedReportDashboardRequest,
    GetReportDashboardConfigsResult,
    GetReportDashboardQueryDataResult,
    GetReportDashboardQueryDataRequest,
    ReportDashboardMetricDefinition,
    convertMetricDefinitionToComponentConfig,
    ReportDashboardPersistedConfig,
} from '@liquitics/transaction';
import { UserProfileReporting } from '@liquitics/transaction';

import { MatDialog } from '@angular/material/dialog';
import { ReportDashboardQueryRequestComponent } from './query-request/report-dashboard-query-request.component';
import { SnapshotService } from '../snapshot/snapshot.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { v4 as uuid } from 'uuid';
import * as moment from 'moment';
import { LocalDBService } from '../service/local-db.service';
import {
    UNMODIFIED_HTML_ICON,
    UNMODIFIED_PDF_ICON,
    UNMODIFIED_XLSX_ICON,
    UNMODIFIED_COMPONENT_INVESTIGATION_ICON,
    MODIFIED_ICON,
    getIconForComponent,
    DASHBOARD_OWNER_ICON,
    DASHBOARD_COLLABORATOR_ICON,
    DASHBOARD_VIEWER_ICON,
    DASHBOARD_ADMIN_ICON,
    DASHBOARD_UNKNOWN_ICON,
    UNMODIFIED_COMPONENT_INVENTORY_ICON
} from './report-dashboard-constants';
import { AppConfig } from '../app.config';



export interface ReportDashboardTreeNode extends TreeNode {
    modified: boolean;
    contentType: 'DASHBOARD' | 'COMPONENT' | 'HTML' | 'INVESTIGATION' | 'INVENTORY' | 'DOWNLOAD' | 'XLSX' | 'PDF' | 'METRIC';
    identifier: string;
    parentReportDashboardConfig?: ReportDashboardConfig;
    subLabel?: string;
    isMarked?: boolean;
}


const ORDERED_DESIGN_CONFIGURATION_IDS = 'OrderedDesignReportDashboardConfigIDs';
const ORDERED_VIEW_CONFIGURATION_IDS = 'OrderedViewReportDashboardConfigIDs';

@Component({
    selector: 'app-report-dashboard-preview-inner',
    template: `<div max-width="100%" max-height="100%" [innerHtml]="innerHTMLToUse"></div>
    `,
    encapsulation: ViewEncapsulation.ShadowDom
})
export class ReportDashboardPreviewInnerComponent {
    @Input()
    innerHTMLToUse: SafeHtml;
}

@Component({
    selector: 'app-report-dashboard',
    templateUrl: './report-dashboard.component.html',
    styleUrls: ['./report-dashboard.component.scss']
})
export class ReportDashboardComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('previewPublishPanel') previewPublishPanel: OverlayPanel;

    subscription: Subscription;
    viewMode: string;
    currentUser: string;
    designReportDashboardNodes: ReportDashboardTreeNode[] = [];
    filteredDesignReportDashboardNodes: ReportDashboardTreeNode[] = [];
    viewReportDashboardNodes: ReportDashboardTreeNode[] = [];
    filteredViewReportDashboardNodes: ReportDashboardTreeNode[] = [];

    selectedNode: ReportDashboardTreeNode;
    contextMenuItems: MenuItem[];

    itemTypeOptions = [
        { label: 'Dashboard', value: 'DASHBOARD_CONFIG' },
        { label: 'Metric', value: 'METRIC_DEFINITION' },
    ];
    itemType = 'DASHBOARD_CONFIG';

    filterOwner = false;
    filterCollaborator = false;
    filterViewer = false;

    nodeSideBarOpened = true;
    treeLoading = true;
    loading = false;
    previewLoading = false;
    previewURL: SafeHtml;
    prewiewHTMLUnsanitized: string;
    previewHTML: SafeHtml;
    previewConfiguration: ReportDashboardConfig;
    previewSplitItems: MenuItem[];
    latestPreviewResult: PreviewReportDashboardResult;

    downloadUrl: any;
    downloadFileName: string;
    inventoryUrl: any;
    inventoryFileName: string;
    investigationColumns: any[];
    investigationFileName: string;
    investigationData: any[];

    dashboardConfigsResult: GetReportDashboardConfigsResult;
    batchIdentifier: string;
    operatingDate: Date;
    maxOperatingDate: Date;

    copiedNode: ReportDashboardTreeNode;
    syntheticColumnBuilderDocument = '';

    showPublishBar = false;


    isReportingAdmin: boolean;
    license: any;

    constructor(
        private dialog: MatDialog,
        private awsUtil: AwsUtil,
        private snapshotService: SnapshotService,
        private sanitizer: DomSanitizer,
        private confirmationService: ConfirmationService,
        private dashboardEventService: DashboardEventService,
        private localDBService: LocalDBService,
        private appConfig: AppConfig,
    ) {
        const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        this.isReportingAdmin = reportingProfile.isReportDashboardAdmin();
        this.license = reportingProfile.getLicense();
    }

    ngOnInit() {
        this.subscription = this.dashboardEventService.viewModeSelectionSubject.subscribe({
            next:
                (mode: string) => {
                    setTimeout(() => {
                        this.viewMode = mode;
                        this.nodeSideBarOpened = true;
                    });
                }
        });
        this.batchIdentifier = this.snapshotService.applicationConfiguration.batchIdentifiers[0].split('=')[1];
        this.loadReportDashboards();
        this.contextMenuItems = [
            {
                label: 'Edit',
                command: (event) => {
                    this.editSelected();
                }
            },
            {
                label: 'Copy',
                command: (event) => {
                    this.copySelected();
                }
            },
            {
                label: 'Paste',
                command: (event) => {
                    this.paste();
                }
            },
            {
                label: 'Delete',
                command: (event) => {
                    this.deleteSelected();
                }
            }
        ];
        if (this.license?.dashboard?.previewPublishing) {
            this.previewSplitItems = [
                {
                    label: 'Preview (for Publishing)',
                    command: (event) => {
                        this.previewReportDashboard(true);
                    }
                },
                {
                    label: 'Publish Latest Preview',
                    command: (event) => {
                        this.previewPublishPanel.toggle(event);
                    }
                },
            ]
        } else {
            this.previewSplitItems = [];
        }
        const biParts = this.batchIdentifier.split('_');
        const operatingDateStr = biParts[0];
        this.operatingDate = moment.utc(operatingDateStr).endOf('day').toDate();
        this.maxOperatingDate = this.operatingDate;
        this.currentUser = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onReportDashboardSelected(event) {
    }

    onOperatingDateSelected(event) {
        this.batchIdentifier = this.getBatchIdentifierForSelectedDate();
    }

    onItemTypeChange(event) {
        this.filterDesignNodes();
    }

    getViewIcon(reportDashboardConfig: ReportDashboardConfig): string | undefined {
        let iconToUse;
        const format = reportDashboardConfig.publishingConfig.emailFormat;
        if (format === 'HTML') {
            iconToUse = UNMODIFIED_HTML_ICON;
        } else if (format === 'PDF') {
            iconToUse = UNMODIFIED_PDF_ICON;
        } else if (format === 'XLSX') {
            iconToUse = UNMODIFIED_XLSX_ICON;
        }
        return iconToUse;
    }

    async loadReportDashboards() {
        this.treeLoading = true;
        try {
            this.designReportDashboardNodes = [];
            this.viewReportDashboardNodes = [];
            let selectedNodeIdentifier;
            if (this.selectedNode) {
                selectedNodeIdentifier = this.selectedNode.identifier;
                this.selectedNode = undefined;
            }
            const result = await this.awsUtil.webAPICall<GetReportDashboardConfigsResult>(WebApiEndpoints.QueryReportDashboardConfigs,
                { batchIdentifier: this.batchIdentifier });
            this.dashboardConfigsResult = result;
            // Dashboard Configs
            const configs: ReportDashboardConfig[] = result.reportDashboardConfigs;
            this.designReportDashboardNodes = configs
                .map((config) => {
                    const node: ReportDashboardTreeNode = this.createReportDashboardNode(config, 'DESIGN');
                    if (config.componentConfigs) {
                        node.children = config.componentConfigs
                            .map((componentConfiguration) => {
                                const child = this.createReportDashboardComponentNode(componentConfiguration);
                                if (!componentConfiguration.identifier) {
                                    componentConfiguration.identifier = uuid();
                                }
                                child.modified = false;
                                const iconToUse = getIconForComponent(componentConfiguration.queryRequest?.usage || '',
                                    componentConfiguration.type,
                                    componentConfiguration.chart?.chartType);
                                child.icon = iconToUse;
                                if (!componentConfiguration.options) {
                                    componentConfiguration.options = {
                                        fullWidth: false
                                    };
                                }
                                return child;
                            });
                    }
                    node.modified = false;
                    node.icon = this.getUnmodifiedDashboardConfigIcon(config);
                    if (!config.identifier) {
                        config.identifier = uuid();
                    }
                    node.identifier = config.identifier;
                    if (!config.publishingConfig) {
                        config.publishingConfig = {
                            schedule: 'NONE',
                            emailRecipients: [],
                            emailFormat: 'HTML',
                            viewableOnline: false,
                        } as ReportDashboardPublishingConfig;
                    }
                    if (node.identifier === selectedNodeIdentifier) {
                        this.selectedNode = node;
                    }
                    return node;
                });

            // Metric Definitions
            const metricDefinitions: ReportDashboardMetricDefinition[] = [
                ...result.reportDashboardMetricDefinitions,
            ];
            this.designReportDashboardNodes.push(...metricDefinitions
                .map((metricDefinition) => {
                    const node: ReportDashboardTreeNode = this.createReportDashboardMetricDefinitionNode(metricDefinition);
                    node.modified = false;
                    node.icon = this.getUnmodifiedDashboardConfigIcon(metricDefinition);
                    if (!metricDefinition.identifier) {
                        metricDefinition.identifier = uuid();
                    }
                    node.identifier = metricDefinition.identifier;
                    return node;
                })
            );
            this.viewReportDashboardNodes = [];
            configs
                .filter((config) => {
                    return config.publishingConfig?.schedule !== 'NONE';
                })
                .forEach((config) => {
                    let format = 'HTML';
                    if (config.publishingConfig.emailFormat !== 'NONE') {
                        format = config.publishingConfig.emailFormat;
                    }
                    const iconToUse = this.getViewIcon(config);
                    const viewNode = {
                        contentType: format,
                        label: config.name,
                        icon: iconToUse,
                        draggable: false,
                        droppable: false,
                        identifier: config.identifier,
                        key: config.identifier,
                        data: config
                    } as ReportDashboardTreeNode;
                    this.viewReportDashboardNodes.push(viewNode);
                    let attachmentIndex = 0;
                    config.componentConfigs
                        .forEach((component, componentIndex) => {
                            if (component.queryRequest?.usage === 'INVESTIGATION') {
                                const investigationNode = {
                                    contentType: 'INVESTIGATION',
                                    label: `${config.name}`,
                                    subLabel: `${component.title}`,
                                    icon: UNMODIFIED_COMPONENT_INVESTIGATION_ICON,
                                    draggable: false,
                                    droppable: false,
                                    identifier: component.identifier,
                                    key: component.identifier + componentIndex,
                                    data: component,
                                    parentReportDashboardConfig: config
                                } as ReportDashboardTreeNode;
                                this.viewReportDashboardNodes.push(investigationNode);
                            } else if (component.queryRequest?.usage === 'INVENTORY') {
                                const inventoryNode = {
                                    contentType: 'XLSX',
                                    label: `${config.name}`,
                                    subLabel: `${component.title}`,
                                    icon: UNMODIFIED_COMPONENT_INVENTORY_ICON,
                                    draggable: false,
                                    droppable: false,
                                    identifier: `${config.identifier}-A${attachmentIndex}`,
                                    key: component.identifier + componentIndex,
                                    data: component,
                                    parentReportDashboardConfig: config
                                } as ReportDashboardTreeNode;
                                this.viewReportDashboardNodes.push(inventoryNode);
                                attachmentIndex++;
                            }
                        });
                });
            this.orderReportDashboardNodes();
        } finally {
            this.treeLoading = false;
        }
    }

    orderReportDashboardNodes() {
        const orderedDesignIds = this.localDBService.getItem(ORDERED_DESIGN_CONFIGURATION_IDS)?.split(',') || [];
        const orderedViewIds = this.localDBService.getItem(ORDERED_VIEW_CONFIGURATION_IDS)?.split(',') || [];

        const sorter = (nodes: ReportDashboardTreeNode[], orderedIds: string[]): ReportDashboardTreeNode[] => {
            return nodes
                .sort((n1, n2) => {
                    const n1Index = orderedIds.indexOf(n1.identifier);
                    const n2Index = orderedIds.indexOf(n2.identifier);
                    if (n1Index === n2Index) {
                        return 0;
                    }
                    if (n1Index === -1) {
                        return 1;
                    }
                    if (n2Index === -1) {
                        return -1;
                    }
                    return n1Index < n2Index ? -1 : 1;
                });
        };


        this.designReportDashboardNodes = sorter(this.designReportDashboardNodes, orderedDesignIds);
        this.filterDesignNodes();
        this.viewReportDashboardNodes = sorter(this.viewReportDashboardNodes, orderedViewIds);
        this.filterViewNodes();
    }

    filterDesignNodes() {
        this.filteredDesignReportDashboardNodes = this.filterNodes(this.designReportDashboardNodes, 'DESIGN');
    }

    filterViewNodes() {
        this.filteredViewReportDashboardNodes = this.filterNodes(this.viewReportDashboardNodes, 'VIEW');
    }

    filterDesignAndViewNodes() {
        this.filterDesignNodes();
        this.filterViewNodes();
    }

    filterNodes(reportDashboardNodes: ReportDashboardTreeNode[], viewMode: 'DESIGN' | 'VIEW') {
        let selectedNodeIdentifier;
        if (this.selectedNode) {
            selectedNodeIdentifier = this.selectedNode.identifier;
            this.selectedNode = undefined;
        }
        return reportDashboardNodes
            .filter((reportDashboardNode) => {
                if (this.itemType === 'METRIC_DEFINITION') {
                    return reportDashboardNode.contentType === 'METRIC';
                } else {
                    return reportDashboardNode.contentType !== 'METRIC';
                }
            })
            .filter((reportDashboardNode) => {
                const reportDashboardConfig = reportDashboardNode.parentReportDashboardConfig ||
                    reportDashboardNode.data as ReportDashboardConfig;
                const isOwner = reportDashboardConfig.meta?.owner === this.currentUser;
                const isCollaborator = (reportDashboardConfig.meta?.collaborators || []).includes(this.currentUser);
                const isViewer = (reportDashboardConfig.meta?.viewers || []).includes(this.currentUser);
                const isParticipant = this.isReportingAdmin || isOwner || isCollaborator || isViewer;
                if (!isParticipant && reportDashboardConfig.meta?.owner !== undefined) {
                    // Owner is set and I'm not a participant in any way, then I shouldn't even be seeing this
                    return false;
                }
                if (!this.filterOwner && !this.filterCollaborator && !this.filterViewer) {
                    // No Filters used, return all
                    return true;
                }
                return (this.filterOwner && isOwner) || (this.filterCollaborator && isCollaborator) || (this.filterViewer && isViewer);
            })
            .map((reportDashboardNode) => {
                if (reportDashboardNode.identifier === selectedNodeIdentifier && viewMode === this.viewMode) {
                    this.selectedNode = reportDashboardNode;
                }
                return reportDashboardNode;
            })
            ;
    }

    createDefaultDashboardConfigMeta(): any {
        return {
            owner: this.awsUtil.cognitoUtil.getCurrentUser().getUsername(),
            publisher: this.awsUtil.cognitoUtil.getCurrentUser().getUsername(),
            collaborators: [],
            viewers: [],
        };
    }

    // Top Level Dashboard
    createReportDashboardNode(reportDashboardConfig: ReportDashboardConfig, viewMode: string) {
        let iconToUse: string;
        let isDroppable: boolean;
        if (viewMode === 'DESIGN') {
            iconToUse = MODIFIED_ICON;
            isDroppable = true;
        } else if (viewMode === 'VIEW') {
            iconToUse = this.getViewIcon(reportDashboardConfig);
        }
        return {
            contentType: 'DASHBOARD',
            label: reportDashboardConfig.name,
            icon: iconToUse,
            draggable: false,
            droppable: isDroppable,
            data: reportDashboardConfig,
            children: [],
            identifier: reportDashboardConfig.identifier,
            key: reportDashboardConfig.identifier,
        } as ReportDashboardTreeNode;
    }

    newReportDashboard() {
        const reportDashboardConfig: ReportDashboardConfig = {
            identifier: uuid(),
            name: `Dashboard${this.designReportDashboardNodes.length + 1}`,
            title: `Dashboard${this.designReportDashboardNodes.length + 1} Title`,
            subTitle: '',
            componentConfigs: [],
            publishingConfig: {
                schedule: 'NONE',
                emailRecipients: [],
                emailFormat: 'NONE',
                viewableOnline: false
            } as ReportDashboardPublishingConfig,
            meta: this.createDefaultDashboardConfigMeta()
        };
        const newReportDashboardNode = this.createReportDashboardNode(reportDashboardConfig, 'DESIGN');
        newReportDashboardNode.identifier = reportDashboardConfig.identifier;
        this.designReportDashboardNodes.unshift(newReportDashboardNode);
        this.selectedNode = newReportDashboardNode;
        this.openReportDashboardConfigDialog(reportDashboardConfig);
        this.recordItemOrders();
        this.filterDesignNodes();
    }

    // RD Component
    createReportDashboardComponentNode(componentConfiguration: ReportDashboardComponentConfig) {
        return {
            contentType: 'COMPONENT',
            label: componentConfiguration.queryRequest?.name,
            modified: true,
            icon: MODIFIED_ICON,
            draggable: true,
            droppable: false,
            data: componentConfiguration,
            identifier: componentConfiguration.identifier,
            key: componentConfiguration.identifier,
        } as ReportDashboardTreeNode;
    }

    newReportDashboardComponent() {
        const reportDashboardNode = this.getSelectedReportDashboardNode();
        if (reportDashboardNode) {
            const componentConfiguration = this.createNewReportDashboardComponentConfig();
            componentConfiguration.queryRequest.name = `Component${reportDashboardNode.children.length + 1}`;
            const newComponentNode = this.createReportDashboardComponentNode(componentConfiguration);
            reportDashboardNode.children.push(newComponentNode);
            reportDashboardNode.expanded = true;
            this.selectedNode = newComponentNode;
            const reportDashboardConfig = reportDashboardNode.data as ReportDashboardConfig;
            reportDashboardConfig.componentConfigs.push(componentConfiguration);
            this.openReportDashboardComponentConfigDialog(componentConfiguration);
        }
    }

    // Metric Definition
    createReportDashboardMetricDefinitionNode(metricDefinition: ReportDashboardMetricDefinition) {
        return {
            contentType: 'METRIC',
            label: metricDefinition.displayName,
            modified: true,
            icon: MODIFIED_ICON,
            draggable: true,
            droppable: false,
            data: metricDefinition,
            identifier: metricDefinition.identifier,
            key: metricDefinition.identifier,
        } as ReportDashboardTreeNode;
    }

    newReportDashboardMetricDefinition() {
        const reportDashboardMetricDefinition: ReportDashboardMetricDefinition = {
            identifier: uuid(),
            type: 'QUERY_BASED',
            name: `Metric${this.designReportDashboardNodes.length + 1}`,
            displayName: `Metric ${this.designReportDashboardNodes.length + 1}`,
            queryBased: {
                queryType: 'TRADE',
                sourceFilters: [],
            },
            meta: this.createDefaultDashboardConfigMeta()
        } as ReportDashboardMetricDefinition;
        const newNode = this.createReportDashboardMetricDefinitionNode(reportDashboardMetricDefinition);
        newNode.identifier = reportDashboardMetricDefinition.identifier;
        this.designReportDashboardNodes.unshift(newNode);
        this.selectedNode = newNode;
        this.openReportDashboardReportDashboardPersistedConfigDialog(reportDashboardMetricDefinition);
        this.recordItemOrders();
        this.filterDesignNodes();
    }

    getSelectedReportDashboardNode(): ReportDashboardTreeNode {
        if (this.selectedNode) {
            if (this.selectedNode.parent) {
                return this.selectedNode.parent as ReportDashboardTreeNode;
            } else {
                return this.selectedNode;
            }
        }
    }

    editSelected() {
        if (this.selectedNode) {
            if (this.selectedNode.contentType === 'COMPONENT') {
                // This is a ReportDashboardComponentConfig
                const configuration = this.selectedNode.data as ReportDashboardComponentConfig;
                this.openReportDashboardComponentConfigDialog(configuration);
            } else if (this.selectedNode.contentType === 'DASHBOARD') {
                // This is a ReportDashboardConfig
                const configuration = this.selectedNode.data as ReportDashboardConfig;
                this.openReportDashboardConfigDialog(configuration);
            } else if (this.selectedNode.contentType === 'METRIC') {
                // This is a ReportDashboardMetricDefinition
                const configuration = this.selectedNode.data as ReportDashboardMetricDefinition;
                this.openReportDashboardReportDashboardPersistedConfigDialog(configuration);
            }
        }
    }

    copySelected() {
        this.copiedNode = this.selectedNode;

        if (this.selectedNode.data) {
            const configAsString = JSON.stringify(this.selectedNode.data, null, 2);
            const selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = configAsString;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);
        }
    }

    cloneReportDashboardComponentTreeNode(source: ReportDashboardTreeNode): ReportDashboardTreeNode {
        const clonedComponentConfig = JSON.parse(JSON.stringify(source.data)) as ReportDashboardComponentConfig;
        clonedComponentConfig.identifier = uuid();
        clonedComponentConfig.title = clonedComponentConfig.title + ' Copy';
        const clonedComponentNode = this.createReportDashboardComponentNode(clonedComponentConfig);
        if (clonedComponentConfig.queryRequest) {
            clonedComponentConfig.queryRequest.name = `${clonedComponentConfig.queryRequest.name} Copy`;
        }
        return clonedComponentNode;
    }

    paste() {
        if (this.copiedNode) {
            if (this.copiedNode.contentType === 'DASHBOARD' || this.copiedNode.contentType === 'METRIC') {
                const clonedPersistedConfig = JSON.parse(JSON.stringify(this.copiedNode.data)) as ReportDashboardPersistedConfig;
                clonedPersistedConfig.identifier = uuid();
                clonedPersistedConfig.name = clonedPersistedConfig.name + ' Copy';
                delete clonedPersistedConfig.lastModified;
                delete clonedPersistedConfig.markedForDeletion;
                clonedPersistedConfig.meta = clonedPersistedConfig.meta || this.createDefaultDashboardConfigMeta();
                clonedPersistedConfig.meta.owner = this.currentUser;
                clonedPersistedConfig.meta.publisher = this.currentUser;
                if (this.copiedNode.contentType === 'DASHBOARD') {
                    const clonedDashboardConfig = clonedPersistedConfig as ReportDashboardConfig;
                    const clonedDashboardNode = this.createReportDashboardNode(clonedDashboardConfig, 'DESIGN');
                    clonedDashboardNode.label = clonedDashboardConfig.name;
                    this.designReportDashboardNodes.unshift(clonedDashboardNode);
                    if (this.copiedNode.children) {
                        clonedDashboardNode.children = this.copiedNode.children
                            .map((childNode: ReportDashboardTreeNode) => {
                                const clonedComponentNode = this.cloneReportDashboardComponentTreeNode(childNode);
                                return clonedComponentNode;
                            });
                    }
                } else if (this.copiedNode.contentType === 'METRIC') {
                    const clonedMetricDefinition = clonedPersistedConfig as ReportDashboardMetricDefinition;
                    const clonedMetricDefinitionNode = this.createReportDashboardMetricDefinitionNode(clonedMetricDefinition);
                    clonedMetricDefinitionNode.label = clonedMetricDefinition.name;
                    this.designReportDashboardNodes.unshift(clonedMetricDefinitionNode);
                }
            } else if (this.copiedNode.contentType === 'COMPONENT') {
                if (this.selectedNode && this.selectedNode.contentType === 'DASHBOARD') {
                    // If no node selected, we can't add a component without a root
                    const clonedComponentNode = this.cloneReportDashboardComponentTreeNode(this.copiedNode);
                    if (!this.selectedNode.children) {
                        this.selectedNode.children = [];
                    }
                    this.selectedNode.children.push(clonedComponentNode);
                    const reportDashboardConfig = this.selectedNode.data as ReportDashboardConfig;
                    reportDashboardConfig.componentConfigs.push(clonedComponentNode.data);
                }
            }
        }
        this.filterDesignNodes();
        this.recordItemOrders();
    }

    onReportDashboardDialogOk(event) {
        const node = this.getSelectedReportDashboardNode();
        node.data.name = node.label;
    }

    // onShowReportDashboardDialog(event) {
    //     setTimeout(() => {
    //         if (this.renameInputTextField) {
    //             this.renameInputTextField.nativeElement.focus();
    //             this.renameInputTextField.nativeElement.select();
    //         }
    //     }, 30);
    // }

    // modificationPermissions(configuration: ReportDashboardConfig): { canModify: boolean, message: string } {
    //     const permissions = {
    //         canModify: false,
    //         message: '',
    //     };
    //     const owner = configuration.meta?.owner;
    //     if (owner) {
    //         const currentUserName = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
    //         if (currentUserName !== owner) {
    //             permissions.canModify = false;
    //             permissions.message = `Configuration: ${configuration.name} is owned by ${owner}. You may not modify it`;
    //         }
    //     }
    //     return permissions;
    // }

    deleteSelected() {
        if (this.selectedNode) {
            if (this.selectedNode.parent) {
                // Component Node
                const reportDashboardNode = this.selectedNode.parent as ReportDashboardTreeNode;
                reportDashboardNode.children = reportDashboardNode.children
                    .filter((child) => {
                        return child !== this.selectedNode;
                    });
                const deletedComponentIdentifier = this.selectedNode.data.identifier;
                // Reset selected to parent
                this.selectedNode = reportDashboardNode;
                reportDashboardNode.modified = true;
                reportDashboardNode.icon = MODIFIED_ICON;
                // Remove the deleted component from the componentConfigs
                (reportDashboardNode.data as ReportDashboardConfig).componentConfigs =
                    (reportDashboardNode.data as ReportDashboardConfig).componentConfigs
                        .filter((cc) => {
                            return cc.identifier !== deletedComponentIdentifier;
                        });
            } else {
                // Dashboard or Metric Node
                const humanType = (this.selectedNode.contentType === 'METRIC') ? 'Metric Definition' : 'Report Dashboard';
                const configuration = this.selectedNode.data as ReportDashboardPersistedConfig;
                if (configuration.meta?.owner !== this.currentUser) {
                    this.confirmationService.confirm({
                        message: `${humanType} ${configuration.name} can only be deleted by its owner: ${configuration.meta?.owner}.`,
                        header: 'Permission Error',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                        },
                        reject: () => {
                        },
                        rejectVisible: false,
                        acceptLabel: 'Close',
                    });
                    return;
                }
                this.confirmationService.confirm({
                    message: `Are you sure you wish to delete ${humanType}: ${this.selectedNode.label}?`,
                    header: `Delete ${humanType}?`,
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: `Permanently DELETE: ${this.selectedNode.label}`,
                    accept: () => {
                        if (configuration.lastModified) {
                            console.log(`=====Marked for deletion and saved`);
                            // This is a saved config
                            configuration.markedForDeletion = true;
                            if (this.selectedNode.contentType === 'METRIC') {
                                this.savePersistedConfigDefinition(configuration as ReportDashboardMetricDefinition, WebApiEndpoints.SaveReportDashboardMetricDefinition);
                            } else {
                                this.saveReportDashboard(configuration as ReportDashboardConfig);
                            }
                        } else if (this.selectedNode.modified) {
                            console.log(`=====Just filtered out by identifier: ${this.selectedNode.identifier} `);
                            this.designReportDashboardNodes = this.designReportDashboardNodes
                                .filter((node) => {
                                    return node.identifier !== this.selectedNode.identifier;
                                });
                            this.filterDesignNodes();
                            this.selectedNode = undefined;
                        } else {
                            console.log(`=====Nothing.....`);
                        }
                    },
                    reject: () => {
                    }
                });
            }
        }
    }
    onReportDashboardNodeDrop(event) {
        event.accept();
    }

    createNewReportDashboardComponentConfig() {
        const component = {
            identifier: uuid(),
            type: 'PIVOT',
            queryRequest: {
                type: 'TRADE',
                usage: 'DASHBOARD',
                sourceFilters: [],
                resultFilters: [],
                sortDescending: false,
            } as ReportDashboardQueryRequest,
            options: {
                fullWidth: false
            }

        } as ReportDashboardComponentConfig;
        return component;
    }
    openReportDashboardConfigDialog(config: ReportDashboardConfig) {
        const dialogRef = this.dialog.open(ReportDashboardConfigComponent, {
            width: '50%',
            height: '80%',
            disableClose: true,
            data: {
                reportDashboardConfig: config,
                designers: this.dashboardConfigsResult.users?.designers || [],
            }
        });
        dialogRef.afterClosed().toPromise()
            .then((returnedConfiguration: ReportDashboardConfig) => {
                if (returnedConfiguration) {
                    this.selectedNode.data = returnedConfiguration;
                    this.selectedNode.modified = true;
                    this.selectedNode.icon = MODIFIED_ICON;
                    this.selectedNode.label = returnedConfiguration.name;
                    // Re-order the child nodes as they may have been modified via the layout builder
                    const identifiers = returnedConfiguration.componentConfigs
                        .map((cc) => {
                            return cc.identifier;
                        });
                    this.selectedNode.children = this.selectedNode.children
                        .sort((n1, n2) => {
                            return identifiers.indexOf((n1.data as ReportDashboardComponentConfig).identifier) -
                                identifiers.indexOf((n2.data as ReportDashboardComponentConfig).identifier);
                        });
                }
            });
    }

    openReportDashboardComponentConfigDialog(config: ReportDashboardComponentConfig) {
        const dialogRef = this.dialog.open(ReportDashboardQueryRequestComponent, {
            width: '80%',
            height: '80%',
            disableClose: true,
            data: {
                customerColumnAliases: this.dashboardConfigsResult.customerColumnAliases,
                systemSyntheticReportColumns: this.dashboardConfigsResult.syntheticReportColumns
                    .filter((src) => {
                        // Only system defined synthetic columns so we can use meta data
                        return src.isSystemDefined;
                    }),
                distinctValues: this.dashboardConfigsResult.distinctValues,
                columnMeta: this.dashboardConfigsResult.columnMeta,
                metricDefinitions: this.dashboardConfigsResult.reportDashboardMetricDefinitions,
                batchIdentifier: this.batchIdentifier,
                configuration: config,
                presetDefinitions: this.dashboardConfigsResult.presetDefinitions,
                title: 'Report Dashboard Component',
                okButtonLabel: 'Ok'
            }
        });
        dialogRef.afterClosed().toPromise()
            .then((returnedConfiguration: ReportDashboardComponentConfig) => {
                if (returnedConfiguration) {
                    this.selectedNode.data = returnedConfiguration;
                    this.selectedNode.modified = true;
                    this.selectedNode.icon = MODIFIED_ICON;
                    this.selectedNode.label = returnedConfiguration.title;
                    if (this.selectedNode.parent) {
                        (this.selectedNode.parent as ReportDashboardTreeNode).modified = true;
                        this.selectedNode.parent.icon = MODIFIED_ICON;
                    }
                }
            });
    }


    openReportDashboardReportDashboardPersistedConfigDialog(persistedDefinition: ReportDashboardPersistedConfig) {

        const metricDefinition = persistedDefinition as ReportDashboardMetricDefinition;
        if (!metricDefinition.type) {
            metricDefinition.type = 'QUERY_BASED';
            const metricAny = metricDefinition as any;
            metricDefinition.queryBased = {
                queryType: metricAny.queryType,
                valueColumns: metricAny.valueColumns,
                fieldDisplays: metricAny.fieldDisplays,
                sourceFilters: metricAny.sourceFilters,
                presetConfig: metricAny.presetConfig,
            }
        }
        const metricDefinitionAny = metricDefinition as any;
        metricDefinitionAny.queryBased = metricDefinitionAny.queryBased || {};
        metricDefinitionAny.ratio = metricDefinitionAny.ratio || {};
        metricDefinitionAny.benchmark = metricDefinitionAny.benchmark || {};

        const dialogRef = this.dialog.open(ReportDashboardQueryRequestComponent, {
            width: '80%',
            height: '80%',
            disableClose: true,
            data: {
                customerColumnAliases: this.dashboardConfigsResult.customerColumnAliases,
                systemSyntheticReportColumns: this.dashboardConfigsResult.syntheticReportColumns
                    .filter((src) => {
                        // Only system defined synthetic columns so we can use meta data
                        return src.isSystemDefined;
                    }),
                distinctValues: this.dashboardConfigsResult.distinctValues,
                columnMeta: this.dashboardConfigsResult.columnMeta,
                metricDefinitions: this.dashboardConfigsResult.reportDashboardMetricDefinitions,
                benchmarkRules: this.dashboardConfigsResult.benchmarkRules,
                batchIdentifier: this.batchIdentifier,
                configuration: convertMetricDefinitionToComponentConfig(metricDefinition),
                presetDefinitions: this.dashboardConfigsResult.presetDefinitions,
                title: 'Metric Definition',
                okButtonLabel: 'Ok',
                reportDashboardPersistedConfig: persistedDefinition,
                isMetricDefinition: true,
                designers: this.dashboardConfigsResult.users?.designers || [],
            }
        });
        dialogRef.afterClosed().toPromise()
            .then((returnedConfiguration: ReportDashboardMetricDefinition) => {
                if (returnedConfiguration) {
                    this.selectedNode.data = returnedConfiguration;
                    this.selectedNode.modified = true;
                    this.selectedNode.icon = MODIFIED_ICON;
                    this.selectedNode.label = returnedConfiguration.displayName;
                    if (this.selectedNode.parent) {
                        (this.selectedNode.parent as ReportDashboardTreeNode).modified = true;
                        this.selectedNode.parent.icon = MODIFIED_ICON;
                    }
                }
            });
    }

    openSyntheticColumnBuilder(event) {
        const dialogRef = this.dialog.open(SyntheticColumnBuilderComponent, {
            width: '80%',
            height: '80%',
            disableClose: true,
            data: {
                customerColumnAliases: this.dashboardConfigsResult.customerColumnAliases,
                syntheticReportColumns: this.dashboardConfigsResult.syntheticReportColumns
                    .filter((src) => {
                        // Filter out system defined synthetic columns
                        return !src.isSystemDefined;
                    }),
                distinctValues: this.dashboardConfigsResult.distinctValues,
                columnMeta: this.dashboardConfigsResult.columnMeta,
                document: this.syntheticColumnBuilderDocument
            }
        });
        dialogRef.afterClosed().toPromise()
            .then((returnedDocument: string) => {
                this.syntheticColumnBuilderDocument = returnedDocument;
            });
    }

    handleDownloadedDashboardContent(
        output: string,
        previewFormat: string,
        fileName: string) {
        this.downloadUrl = undefined;
        if (previewFormat === 'HTML') {
            setTimeout(() => {
                this.prewiewHTMLUnsanitized = output;
                this.previewHTML = this.sanitizer.bypassSecurityTrustHtml(`${output}`);
                this.previewLoading = false;
                this.nodeSideBarOpened = false;
            }, 50);
        } else if (previewFormat === 'XLSX' || previewFormat === 'PDF') {
            const buffer = Buffer.from(output, 'base64');
            const blobType = (previewFormat === 'XLSX') ?
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
            const blob: any = new Blob([buffer], { type: blobType });
            this.downloadUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
            this.downloadFileName = `${fileName}.${previewFormat.toLowerCase()}`;
            this.previewLoading = false;
        }
    }

    showInventoryLink(previewResult: PreviewReportDashboardResult, previewFileName: string) {
        if (previewResult.outputType !== 'XLSX' && previewResult.xlsxBase64Output !== undefined) {
            const buffer = Buffer.from(previewResult.xlsxBase64Output, 'base64');
            const blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const blob: any = new Blob([buffer], { type: blobType });
            this.inventoryUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
            this.inventoryFileName = `${previewFileName}-inventory.xlsx`;
        }
    }

    clearAllDisplayedResults() {
        this.previewHTML = undefined;
        this.investigationFileName = undefined;
        this.investigationData = undefined;
        this.downloadUrl = undefined;
        this.downloadFileName = undefined;
        this.inventoryUrl = undefined;
        this.inventoryFileName = undefined;
    }

    previewReportDashboard(forPublishing: boolean, previousResult?: PreviewReportDashboardResult) {
        this.previewLoading = true;
        this.clearAllDisplayedResults();
        let previewFileName: string;
        const reportDashboardNode = this.getSelectedReportDashboardNode();
        if (this.selectedNode.contentType === 'COMPONENT') {
            const clonedPreviewComponent = JSON.parse(JSON.stringify(this.selectedNode.data)) as ReportDashboardComponentConfig;
            this.previewConfiguration = {
                identifier: `preview-${uuid()}`,
                name: `Preview`,
                title: `Preview`,
                subTitle: `${moment.utc(this.operatingDate).format('YYYY-MM-DD')}`,
                componentConfigs: [
                    clonedPreviewComponent
                ],
                publishingConfig: {
                    schedule: 'NONE',
                    emailRecipients: [],
                    emailFormat: 'NONE',
                    viewableOnline: false
                } as ReportDashboardPublishingConfig,
                meta: {
                    owner: this.awsUtil.cognitoUtil.getCurrentUser().getUsername(),
                    publisher: this.awsUtil.cognitoUtil.getCurrentUser().getUsername()
                }
            };
            previewFileName = this.selectedNode.label;
        } else {
            this.previewConfiguration = JSON.parse(JSON.stringify(reportDashboardNode.data)) as ReportDashboardConfig;
            this.previewConfiguration.identifier = `preview-${uuid()}`;
            this.previewConfiguration.componentConfigs = reportDashboardNode.children
                .map((childNode) => {
                    const clonedChildComponent = JSON.parse(JSON.stringify(childNode.data)) as ReportDashboardComponentConfig;
                    return clonedChildComponent;
                });
            previewFileName = this.previewConfiguration.name;
        }
        this.previewConfiguration.componentConfigs
            .forEach((clonedPreviewComponent, componentIndex: number) => {
                const isDownload = this.previewConfiguration.componentConfigs[0].queryRequest?.usage === 'DOWNLOAD';
                if (isDownload) {
                    // For download mode, we are creating results in the proper named config as we need human retrieval
                    const rdConfig = reportDashboardNode.data as ReportDashboardConfig;
                    clonedPreviewComponent.identifier = `${rdConfig.name}-${clonedPreviewComponent.title}`;
                } else {
                    // Otherwise we create output in the random preview uuid folder
                    clonedPreviewComponent.identifier = `${this.previewConfiguration.identifier}-${componentIndex}`;
                }
            });
        let previewFormat = 'HTML';
        if (this.previewConfiguration.publishingConfig.emailFormat === 'XLSX') {
            previewFormat = 'XLSX';
        } else if (this.previewConfiguration.publishingConfig.emailFormat === 'PDF') {
            previewFormat = 'PDF';
        }
        let previewRequest;
        if (previousResult) {
            previewRequest = previousResult.request;
            previewRequest.type = 'CONTINUE';
            previewRequest.queryExecutionIds = previousResult.queryExecutionIds;
        } else {
            previewRequest = {
                type: 'NEW',
                reportDashboardConfig: this.previewConfiguration,
                batchIdentifier: this.batchIdentifier,
                format: previewFormat,
                queryExecutionIds: previousResult?.queryExecutionIds,
                publishable: forPublishing
            } as PreviewReportDashboardRequest;
        }

        // Temp
        // previewRequest.reportDashboardConfig.componentConfigs =
        //     [
        //         {
        //             type: "REGISTERED",
        //             registeredReportRequest: {
        //                 "registeredReportType": "PreEODCheck"
        //             },
        //             options: {
        //                 "fullWidth": false
        //             },
        //             title: "PreEODCheck Test",
        //         }
        //     ]



        this.awsUtil.webAPICall<PreviewReportDashboardResult>(WebApiEndpoints.PreviewReportDashboard,
            previewRequest, true)
            .then((result: PreviewReportDashboardResult) => {
                const isInvestigationOnly = this.previewConfiguration.componentConfigs.length === 1 &&
                    this.previewConfiguration.componentConfigs[0].queryRequest?.usage === 'INVESTIGATION';
                if (result.queryStatus === 'SUCCEEDED') {
                    if (isInvestigationOnly) {
                        // the response is the queryId
                        this.previewLoading = false;
                        let identifier = this.previewConfiguration.componentConfigs[0].identifier;
                        if (previousResult) {
                            identifier = previousResult.request.reportDashboardConfig.componentConfigs[0].identifier;
                        }
                        this.fetchAndDisplayInvestigation(identifier, previewFileName);
                    } else {
                        let output;
                        if (result.outputType === 'HTML') {
                            output = result.htmlOutput;
                        } else if (result.outputType === 'PDF') {
                            output = result.pdfBase64Output;
                        } else if (result.outputType === 'XLSX') {
                            output = result.xlsxBase64Output;
                        }
                        this.handleDownloadedDashboardContent(output, result.outputType, previewFileName);
                        this.showInventoryLink(result, previewFileName);
                    }
                    this.latestPreviewResult = result;
                } else if (result.queryStatus === 'RUNNING' || result.queryStatus === 'QUEUED') {
                    // Need to keep retrying
                    this.confirmationService.confirm({
                        message: 'The query requested still appears to be running. Would you like to continue waiting?',
                        header: 'Keep waiting?',
                        icon: 'pi pi-clock',
                        accept: () => {
                            this.previewReportDashboard(forPublishing, result);
                        },
                        reject: () => {
                        },
                        rejectVisible: true,
                        acceptLabel: 'Continue waiting',
                        rejectLabel: 'Cancel'
                    });
                }
            })
            .catch((err) => {
                this.previewLoading = false;
                this.reportError(err, 'Preview Error');
            });
    }

    getBatchIdentifierForSelectedDate(): string {
        const biParts = this.batchIdentifier.split('_');
        biParts[0] = moment(this.operatingDate).format('YYYY-MM-DD');
        return biParts.join('_');
    }

    fetchAndDisplayInvestigation(identifier: string, fileName: string) {
        this.loading = true;
        this.previewHTML = undefined;
        this.investigationFileName = undefined;
        this.investigationData = undefined;
        this.awsUtil.webAPICall<GetReportDashboardQueryDataResult>(WebApiEndpoints.QueryReportDashboardData,
            {
                queryName: identifier,
                batchIdentifier: this.batchIdentifier,
            } as GetReportDashboardQueryDataRequest)
            .then((result: GetReportDashboardQueryDataResult) => {
                if (result.errorMessage) {
                    this.loading = false;
                    this.reportError({ error: `Failed to download data: ${result.errorMessage}` }, 'Download Error');
                } else {
                    const columnsMeta = [];
                    result.attributeColumns
                        .forEach((col) => {
                            columnsMeta.push({ field: col, header: col, type: 'string' });
                        });
                    result.valueColumns
                        .forEach((col) => {
                            columnsMeta.push({ field: col, header: col, type: 'number' });
                        });
                    this.investigationColumns = columnsMeta;
                    this.investigationFileName = fileName;
                    this.investigationData = result.data;
                    this.loading = false;
                    this.nodeSideBarOpened = false;
                }
            })
            .catch((err) => {
                this.loading = false;
                this.reportError(err, 'Saved Report Error');
            });
    }

    viewSavedReportDashboard() {
        const node = this.getSelectedReportDashboardNode();
        this.clearAllDisplayedResults();
        if (node.contentType === 'HTML' || node.contentType === 'XLSX' || node.contentType === 'PDF') {
            this.previewLoading = true;
            const previewFormat = node.contentType;
            this.awsUtil.webAPICall<string>(WebApiEndpoints.QuerySavedReportDashboard,
                {
                    identifier: node.identifier,
                    batchIdentifier: this.getBatchIdentifierForSelectedDate(),
                    format: previewFormat,
                } as ViewSavedReportDashboardRequest, true)
                .then((response: string) => {
                    let fileName = node.label;
                    if (node.subLabel) {
                        fileName += `-${node.subLabel}`;
                    }
                    this.handleDownloadedDashboardContent(response, previewFormat, fileName);
                })
                .catch((err) => {
                    this.previewLoading = false;
                    this.reportError(err, 'Saved Report Error');
                });
        } else if (node.contentType === 'INVESTIGATION') {
            this.previewLoading = false;
            this.fetchAndDisplayInvestigation(node.identifier, node.label);
        }
    }

    fixReportDashboardConfig(reportDashboardConfig: ReportDashboardConfig) {
        // Make sure component identifiers are unique
        reportDashboardConfig.componentConfigs
            .reduce((identifiers, cc) => {
                if (identifiers.includes(cc.identifier)) {
                    cc.identifier = uuid();
                }
                identifiers.push(cc.identifier);
                return identifiers;
            }, []);
    }

    preValidateReportDashboardConfig(reportDashboardConfig: ReportDashboardConfig) {
        reportDashboardConfig.componentConfigs
            .reduce((requestNames, cc) => {
                if (cc.queryRequest) {
                    if (requestNames.includes(cc.queryRequest.name)) {
                        throw new Error(`Cannot have multiple components with the same name: ${cc.queryRequest.name}`);
                    }
                    requestNames.push(cc.queryRequest.name);
                }
                return requestNames;
            }, []);
    }
    saveSelectedReportDashboard() {
        const node = this.getSelectedReportDashboardNode();
        const persistedConfig = node.data as ReportDashboardPersistedConfig;
        if (node.contentType === 'DASHBOARD') {
            const reportDashboardConfig = persistedConfig as ReportDashboardConfig;
            this.fixReportDashboardConfig(reportDashboardConfig);
            try {
                this.preValidateReportDashboardConfig(reportDashboardConfig);
            } catch (err) {
                this.reportError(err, 'Pre-save Validation Failure');
                return;
            }
        } else if (node.contentType === 'METRIC') {
            // Do nothing I guess... revisit this later
        } else {
            this.reportError('Can only save a Dashboard Config or a Metric Definition', 'Invalid Configuration');
            return;
        }

        if (!persistedConfig.meta?.owner) {
            this.confirmationService.confirm({
                message: `${persistedConfig.name} currently has no owner. Take ownership and continue saving?`,
                header: 'Take ownership and save?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    persistedConfig.meta = persistedConfig.meta || this.createDefaultDashboardConfigMeta();
                    persistedConfig.meta.owner = this.currentUser;
                    if (node.contentType === 'DASHBOARD') {
                        this.saveReportDashboard(persistedConfig as ReportDashboardConfig);
                    } else if (node.contentType === 'METRIC') {
                        this.savePersistedConfigDefinition(persistedConfig as ReportDashboardMetricDefinition, WebApiEndpoints.SaveReportDashboardMetricDefinition);
                    }
                },
                reject: () => {
                    this.treeLoading = false;
                },
                rejectVisible: true,
                acceptLabel: 'Take Ownership & Save',
                rejectLabel: 'Cancel'
            });
            return;
        } else {
            if (persistedConfig.meta.owner !== this.currentUser &&
                !(persistedConfig.meta.collaborators || []).includes(this.currentUser) &&
                !this.isReportingAdmin) {
                this.confirmationService.confirm({
                    message: `Dashboard ${persistedConfig.name} is not owned by you nor are you a collaborator. You do not have permission to modify.`,
                    header: 'Permission Error',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.treeLoading = false;
                    },
                    reject: () => {
                        this.treeLoading = false;
                    },
                    rejectVisible: false,
                    acceptLabel: 'Close',
                });
                return;
            }
        }
        // If it gets to here, its a permissable save.
        if (node.contentType === 'DASHBOARD') {
            this.saveReportDashboard(persistedConfig as ReportDashboardConfig);
        } else if (node.contentType === 'METRIC') {
            this.savePersistedConfigDefinition(persistedConfig as ReportDashboardMetricDefinition, WebApiEndpoints.SaveReportDashboardMetricDefinition);
        }
    }

    getUnmodifiedDashboardConfigIcon(persistedConfig: ReportDashboardPersistedConfig) {
        if (persistedConfig.meta?.owner === this.currentUser) {
            return DASHBOARD_OWNER_ICON;
        } else if ((persistedConfig.meta?.collaborators || []).includes(this.currentUser)) {
            return DASHBOARD_COLLABORATOR_ICON;
        } else if ((persistedConfig.meta?.viewers || []).includes(this.currentUser)) {
            return DASHBOARD_VIEWER_ICON;
        } else if (this.isReportingAdmin && persistedConfig.meta?.owner !== undefined) {
            return DASHBOARD_ADMIN_ICON;
        } else {
            return DASHBOARD_UNKNOWN_ICON;
        }
    }

    async saveReportDashboard(configuration: ReportDashboardConfig): Promise<boolean> {
        this.treeLoading = true;
        try {
            await this.awsUtil.webAPICall<void>(WebApiEndpoints.SaveReportDashboardConfig, configuration, true)
            const node = this.getSelectedReportDashboardNode();
            node.modified = false;
            node.icon = this.getUnmodifiedDashboardConfigIcon(configuration);
            if (!configuration.markedForDeletion) {
                this.reloadReportDashboards();
            } else {
                this.selectedNode = undefined;
                this.designReportDashboardNodes = this.designReportDashboardNodes
                    .filter((n) => {
                        return n.identifier !== node.identifier;
                    });
                this.filterDesignNodes();
                this.treeLoading = false;
            }
            return true;
        } catch (err) {
            this.reportError(err, 'Saving Error');
            this.treeLoading = false;
            return false;
        }
    }

    async savePersistedConfigDefinition(persistedConfigDefinition: ReportDashboardPersistedConfig, apiPath: string): Promise<boolean> {
        this.treeLoading = true;
        try {
            await this.awsUtil.webAPICall<void>(apiPath, persistedConfigDefinition, true)
            const node = this.getSelectedReportDashboardNode();
            node.modified = false;
            node.icon = this.getUnmodifiedDashboardConfigIcon(persistedConfigDefinition);
            if (!persistedConfigDefinition.markedForDeletion) {
                this.reloadReportDashboards();
            } else {
                this.selectedNode = undefined;
                this.designReportDashboardNodes = this.designReportDashboardNodes
                    .filter((n) => {
                        return n.identifier !== node.identifier;
                    });
                this.filterDesignNodes();
                this.treeLoading = false;
            }
            return true;
        } catch (err) {
            this.reportError(err, 'Saving Error');
            this.treeLoading = false;
            return false;
        }
    }

    reloadReportDashboards() {
        const modifiedNodes = this.designReportDashboardNodes
            .filter((node) => {
                return node.modified === true;
            });
        if (modifiedNodes.length > 0) {
            this.confirmationService.confirm({
                message: 'You have unsaved changes. Are you sure you want to reload?',
                header: 'Reload all configurations?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.loadReportDashboards();
                },
                reject: () => {
                    this.treeLoading = false;
                },
                rejectVisible: true,
                acceptLabel: 'Yes',
                rejectLabel: 'Cancel'
            });
        } else {
            this.loadReportDashboards();
        }


    }

    reportError(err: any, title: string) {
        this.confirmationService.confirm({
            message: err.error || err.message,
            header: title,
            icon: 'pi pi-exclamation-triangle',
            rejectVisible: false,
            acceptLabel: 'OK'
        });
    }

    moveNode(direction: string) {
        if (this.selectedNode) {
            let nodes: ReportDashboardTreeNode[];
            if (this.viewMode === 'DESIGN') {
                nodes = this.designReportDashboardNodes;
            } else {
                nodes = this.viewReportDashboardNodes;
            }
            const isComponentMove = this.selectedNode.contentType === 'COMPONENT';
            if (isComponentMove) {
                nodes = (this.selectedNode.parent.children) as ReportDashboardTreeNode[];
            }
            const selectedIndex = nodes.findIndex((c: ReportDashboardTreeNode) => {
                return this.selectedNode.identifier === c.identifier;
            });
            if (selectedIndex > -1) {
                let newIndex: number;
                if (direction === 'TOP') {
                    newIndex = 0;
                } else if (direction === 'UP') {
                    newIndex = Math.max(selectedIndex - 1, 0);
                } else if (direction === 'DOWN') {
                    newIndex = Math.min(selectedIndex + 1, nodes.length - 1);
                } else if (direction === 'BOTTOM') {
                    newIndex = nodes.length - 1;
                }
                const upperNodes = nodes.slice(0, selectedIndex);
                const lowerNodes = nodes.slice(selectedIndex + 1);
                const upperAndLower = [...upperNodes, ...lowerNodes];
                const newNodes: ReportDashboardTreeNode[] = [];
                for (let i = 0; i < upperAndLower.length; i++) {
                    if (newIndex === i) {
                        newNodes.push(this.selectedNode);
                    }
                    newNodes.push(upperAndLower[i]);
                }
                if (newIndex === upperAndLower.length) {
                    newNodes.push(this.selectedNode);
                }
                if (this.viewMode === 'DESIGN') {
                    if (isComponentMove) {
                        this.selectedNode.parent.children = newNodes;
                        (this.selectedNode.parent.data as ReportDashboardConfig).componentConfigs = newNodes
                            .map((newNode) => {
                                return newNode.data;
                            });
                        (this.selectedNode.parent as ReportDashboardTreeNode).modified = true;
                    } else {
                        this.designReportDashboardNodes = newNodes;
                        this.filterDesignNodes();
                        this.recordItemOrders();
                    }
                } else {
                    this.viewReportDashboardNodes = newNodes;
                    this.filterViewNodes();
                    this.recordItemOrders();
                }
            }
        }
    }

    recordItemOrders() {
        let nodes: ReportDashboardTreeNode[];
        let idConst;
        if (this.viewMode === 'DESIGN') {
            nodes = this.designReportDashboardNodes;
            idConst = ORDERED_DESIGN_CONFIGURATION_IDS;
        } else {
            nodes = this.viewReportDashboardNodes;
            idConst = ORDERED_VIEW_CONFIGURATION_IDS;
        }
        const orderedIds = nodes
            .map((n) => {
                return n.identifier;
            })
            .join(',');
        this.localDBService.setItem(idConst, orderedIds);
    }

}
